import { FC, useContext } from "react";
import { AvatarCheering, AvatarHoldingCards } from "..";
import { BoardContext } from "../../../context";
import { useWindowDimensions } from "../../../hooks";
import { adjustEllipseTangentAngle } from "./helpers";

interface IAvatarPosition {
    avatarProps: {
        index: number,
        player: any,
        ellipseWidth: number,
        radius: number,
        currentAngleInDegrees: number,
        onePercentageOfBrowserWidth: number,
        avatarColor: string
    }
}

const AvatarPosition: FC<IAvatarPosition> = (props) => {
    const { index, ellipseWidth, currentAngleInDegrees, onePercentageOfBrowserWidth, avatarColor } = props.avatarProps;

    const { width } = useWindowDimensions();
    const { isAvatarCheering, renderInitialCoins } = useContext(BoardContext);

    const wrapper_of_avatar_sprint_png_height = 300;
    const scale_percentage_of_the_avatar = 0.7;
    const scalability_percentage = onePercentageOfBrowserWidth * scale_percentage_of_the_avatar;
    const positioning_error = wrapper_of_avatar_sprint_png_height / 2 - (scalability_percentage * wrapper_of_avatar_sprint_png_height * 0.5) / 2;

    let initialRippleAnimation = "";

    if (renderInitialCoins) {
        initialRippleAnimation = `animation_ripple animation_ripple_delay_${(index + 1) * 4} `
    }

    return (
        <div >

            <div className="center_horizontally_and_vertically" style={{ width: "20px", height: "20px", position: "relative" }}>
                <div className="position_avatar_along_the_tanget" style={{ width: `${width * 0.16}px`, height: `${width * 0.14}px`, left: `-${width * 0.15}px`, transform: `rotate(${adjustEllipseTangentAngle(currentAngleInDegrees, ellipseWidth, ellipseWidth)}deg)` }}>
                    <div className="position_avatar_box_to_the_bottom"  >

                        <div className={`non_scalable_wrapper ${initialRippleAnimation}`} style={{ position: "relative", bottom: `-${positioning_error}px` }}>
                            <div className="scalable_wrapper" style={{ height: `${wrapper_of_avatar_sprint_png_height}px`, transform: `scale(${scalability_percentage})` }}>
                                {isAvatarCheering ? <AvatarCheering avatarColor={avatarColor} /> : <AvatarHoldingCards avatarColor={avatarColor} />}
                            </div>
                        </div>



                    </div>
                </div>
            </div>

        </div>
    )
}

export default AvatarPosition;